/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ orgName: NonNullable<unknown> }} Partner_Org_Contract_Cancel_TitleInputs */



/**
* | output |
* | --- |
* | "Cancel the contract for {orgName}?" |
*
* @param {Partner_Org_Contract_Cancel_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_cancel_title = /** @type {((inputs: Partner_Org_Contract_Cancel_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Cancel_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Den Vertrag für ${i?.orgName} stornieren?`)
	return /** @type {LocalizedString} */ (`Cancel the contract for ${i?.orgName}?`)
});